var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-phone-setting',{ref:"form",staticClass:"pt-phone-setting__withData",on:{"getCode":_vm.getCode,"editUserMobile":_vm.editUserMobile}})
}
var staticRenderFns = []

export { render, staticRenderFns }